import { useState, useEffect, useRef } from 'react';
import { LocalJsonStorage } from 'utils/storage';

function usePersistedState(initialValue, paramsOrKey) {
  let key;
  let ttl;
  const storageRef = useRef(LocalJsonStorage);
  const firstLoadRef = useRef(true);

  if (typeof paramsOrKey === 'object') {
    ({ key, ttl } = paramsOrKey);
    if (paramsOrKey.storage) {
      storageRef.current = paramsOrKey.storage;
    }
  } else {
    key = paramsOrKey;
  }

  const [state, setState] = useState(() => (key && storageRef.current.get(key)) || initialValue);

  useEffect(() => {
    if (firstLoadRef.current) {
      firstLoadRef.current = false;
      return;
    }
    if (!key) {
      return;
    }
    
    setState(storageRef.current.get(key) || initialValue);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => {
    if (!key) {
      return;
    }
    storageRef.current.set({
      key,
      value: state,
      ttl,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, ttl]);
  return [state, setState];
}

export default usePersistedState;
